import getButtonStyles from "@/lib/helpers/getButtonStyles";
import useFocus from "@/lib/hooks/interactions/other/useFocus";
import { ButtonPropsType, useHover } from "@/lib/main";

export default function Button({
  children,
  color,
  className,
  disabled,
  fullWidth,
  id,
  onBlur,
  onClick,
  onFocus,
  onMouseEnter,
  onMouseLeave,
  ref,
  size,
  style,
  type,
  ...rest
}: ButtonPropsType) {
  const resolvedColor = color || "outlined";
  const resolvedSize = size || "md";

  const { isFocused, onFocus: setFocused, onBlur: setBlurred } = useFocus();
  const {
    isHovered,
    onMouseEnter: setHovered,
    onMouseLeave: setUnhovered,
  } = useHover();

  const defaultStyle = getButtonStyles({
    color: resolvedColor,
    disabled,
    fullWidth,
    size: resolvedSize,
    isFocused,
    isHovered,
  });

  const styles = {
    ...defaultStyle,
    ...style,
  };

  const handleFocus: React.FocusEventHandler<HTMLButtonElement> = (event) => {
    setFocused();
    onFocus?.(event);
  };

  const handleBlur: React.FocusEventHandler<HTMLButtonElement> = (event) => {
    setBlurred();
    onBlur?.(event);
  };

  const handleMouseEnter: React.MouseEventHandler<HTMLButtonElement> = (
    event,
  ) => {
    setHovered();
    onMouseEnter?.(event);
  };

  const handleMouseLeave: React.MouseEventHandler<HTMLButtonElement> = (
    event,
  ) => {
    setUnhovered();
    onMouseLeave?.(event);
  };

  return (
    <button
      {...rest}
      className={className}
      disabled={disabled}
      id={id && id}
      onBlur={handleBlur}
      onClick={onClick}
      onFocus={handleFocus}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={ref}
      style={styles}
      type={type}
    >
      {children}
    </button>
  );
}
